import { render, staticRenderFns } from "./Indicacoes.vue?vue&type=template&id=583a25e2&"
import script from "./Indicacoes.vue?vue&type=script&lang=js&"
export * from "./Indicacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports